<template>
  <el-row class="editor-list-header">
    <el-col class="order" :span="1">
      <span class="inside">序号</span>
    </el-col>
    <el-col class="source" :span="11">原文</el-col>
    <el-col class="target" :span="12">译文</el-col>
  </el-row>
</template>

<script>
export default {
  name: "TableHeader"
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>